import {Injectable} from '@angular/core';
import {HttpParams} from '@angular/common/http';
import {KeyValue} from '@angular/common';
// @ts-ignore
import {Chart} from 'chart.js';
import {
  ABNORMAL_PROPERTIES,
  AM,
  CHART_TYPE,
  COLLECTION_NAME,
  HEISHI_TOUTA_PROPERTIES,
  HEISHI_WASUU,
  IS_PM,
  KEISHA_SHUBETSU,
  KEISHAHIBETSUFILE_PROPERTY, METER_SHUBETSU, NO_DATA_CLASS_PROPATIES,
  PM,
  REGEX_SHIYOULOT_KEY, SHIYOULOT_KEY_SUFFIX, SHUBETSU_LIST,
  TAIOU_PROPERTIES, TAISOKU, VACCINE,
  WEEK
} from '../../shared/constants';
import {Subscription} from 'rxjs';
import {FormGroup, NgForm} from '@angular/forms';
import cloneDeep from 'lodash-es/cloneDeep';
import {
  HeishiToutaTeiseiWasuu,
  KeyString,
  ShiyoulotKey, ToDelete, WithNullable,
  yyyyMMdd
} from '../../shared/typeAliases';
import {KeishaHibetsuFile} from '../../shared/interfaces/keisha-hibetsu-file';
import {MatDialogRef} from '@angular/material/dialog';
import {genTentouDefaultValue} from './keisha-hibetsu-file.service';
import {ShiyoulotHibetsuFile} from '../../shared/interfaces/shiyoulot-hibetsu-file';
import {ShiyoulotV2} from '../../shared/interfaces/shiyoulot';
import {Keisha} from '../../shared/interfaces/keisha';
import {Vaccine} from '../../shared/interfaces/vaccine';
import {AbstractEvent} from '../../shared/interfaces/abstract-event';
import {TaisokuEvent} from '../../shared/interfaces/taisoku-event';
import {VaccineEvent} from '../../shared/interfaces/vaccine-event';

interface dateRangeFormGroup extends FormGroup {
  value: {
    fcStart: string,
    fcEnd: string,
  }
}

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  // CommonServiceは/ionicからも参照しているが、
  // constructorで引数を入れると/ionic側でうまく動作しなくなる
  constructor() { }

  // https://stackoverflow.com/a/52558097
  /**
   *
   * @param paramName
   */
  getParamValueQueryString(paramName: string) {
    const url = window.location.href;
    let paramValue;
    if (url.includes('?')) {
      const httpParams = new HttpParams({ fromString: url.split('?')[1] });
      paramValue = httpParams.get(paramName);
    }
    return paramValue;
  }

  /**
   *
   * @param date
   */
  dateRegularization(date: Date): Date {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }

  // https://web.plus-idea.net/on/javascript-date-string-convert/
  /**
   *
   * @param dt
   */
  getDateWithString(dt: Date = new Date()): yyyyMMdd {
    const y = dt.getFullYear();
    const m = ('00' + (dt.getMonth() + 1)).slice(-2);
    const d = ('00' + dt.getDate()).slice(-2);
    const result = y + '-' + m + '-' + d;
    return result;
  }

  /**
   *
   * @param dt
   */
  getTimeWithString(dt: Date = new Date()) {
    const h = ('00' + dt.getHours()).slice(-2);
    const m = ('00' + dt.getMinutes()).slice(-2);
    const s = ('00' + dt.getSeconds()).slice(-2);
    return h + '-' + m + '-' + s;
  }

  /**
   * fromDate、toDateで指定した期間の
   * 日付文字列(yyyy-MM-dd)のarrayを返す
   * @param fromDate :'yyyy-MM-dd'
   * @param toDate :'yyyy-MM-dd'
   */
  genDateStringInTerm(fromDate: string, toDate: string): yyyyMMdd[] {
    const regex = /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
    if(!(regex.test(fromDate) && regex.test(fromDate))) {
      return [];
    }
    const array = [];
    while (fromDate <= toDate) {
      array.push(fromDate);
      fromDate = this.genOffsetDateWithStandardDateString(fromDate, 1);
    }
    return array;
  }

  /**
   *
   * @param date
   */
  getNextDate(date: Date): Date {
    const toDateOneDayAfter = this.dateRegularization(new Date(date));
    toDateOneDayAfter.setDate(date.getDate() + 1);
    return toDateOneDayAfter;
  }

  /**
   *
   * @param offset
   */
  genOffsetDate(offset: number): Date {
    const date = new Date();
    return new Date(date.setDate(date.getDate() + offset));
  }

  /**
   *
   * @param standardDate
   * @param offset
   */
  genOffsetDateWithStandardDate(standardDate: Date, offset: number): Date {
    const date = new Date(standardDate);
    return new Date(date.setDate(date.getDate() + offset));
  }

  /**
   *
   * @param standardDateString
   * @param offset
   */
  genOffsetDateWithStandardDateString(standardDateString: yyyyMMdd, offset: number): yyyyMMdd {
    const ymdArray = standardDateString.split('-');
    const date = new Date();
    date.setFullYear(Number(ymdArray[0]), Number(ymdArray[1]) -1, Number(ymdArray[2]));
    return this.getDateWithString(new Date(date.setDate(date.getDate() + offset)));
  }

  // グラフのラベルを生成
  /**
   *
   * @param chartType
   * @param days
   * @param kijunDate
   */
  genDateLabelForChart(chartType: string, days: number, kijunDate: yyyyMMdd) {
    let date = kijunDate;
    let count = 0;
    const labels =[];
    while (count < days) {
      if (chartType === CHART_TYPE.temperature) {
        labels.unshift(IS_PM + date.slice(-5));
      }
      labels.unshift(date.slice(-5));
      date = this.genOffsetDateWithStandardDateString(date, -1);
      count++;
    }
    // console.log('labels:', labels);
    return labels;
  }

  /**
   * 直近の日付を「今日」や「昨日」などに置き換える。。
   * @param standardDate
   */
  replaceRecentDateInWord(standardDate: string): string {
    const today = this.getDateWithString();
    const dateDiff = this.getDateDiff(today, standardDate);
    if (dateDiff === -7) {
      return '１週間前';
    } else if (dateDiff >= -6 && dateDiff <= -2) {
      return Math.abs(dateDiff) + '日前';
    } else if (dateDiff === -1) {
      return '昨日';
    } else if (dateDiff === 0) {
      return '今日';
    } else if (dateDiff === 1) {
      return '明日';
    } else if (dateDiff >= 2 && dateDiff <= 6) {
      return Math.abs(dateDiff) + '日後';
    } else if (dateDiff === 7) {
      return '１週間後';
    }
    return standardDate;
  }

  /**
   * 時分秒→分へ変換
   * @param hansouMeter
   */
  calcHMStoMinutes(hansouMeter: string) {
    const hmsArr = hansouMeter.split(':');
    const minute = this.numToNumber(hmsArr[0]) * 60
      + this.numToNumber(hmsArr[1])
      + this.numToNumber(hmsArr[2]) / 60;
    return minute;
  }

  /**
   *
   */
  getAMPM() {
    const date = new Date();
    return date.getHours() < 12 ? AM : PM;
  }

  /**
   * offsetからquantity個の連番を生成する。
   * @example
   * genSequentialNumber(3, 5);
   * // expected output: [5, 6, 7]
   * @param quantity 生成する連番の個数
   * @param offset 連番の始点
   */
  genSequentialNumber(quantity: number, offset = 1) {
    return [...Array(quantity)].map((_, i) => i+offset);
  }

  /**
   * offsetからquantity個のnumberObjを生成する。
   * @example
   * genSequentialNumberObj(3, 5);
   * // expected output: [{ton: 5, kg: 5000}, {ton: 6, kg: 6000}, {ton: 7, kg: 7000}]
   * @param quantity 生成する連番の個数
   * @param offset 連番の始点
   */
  genSequentialNumberObj(quantity: number, offset = 1) {
    return [...Array(quantity)].map((_, i) => {
      return { ton: i+offset, kg: (i+offset) * 1000 };
    });
  }

  /**
   * 鶏舎のfeedTankObjListを生成
   * 0 ~ 鶏舎のタンク容量(ton) までの feedTankObj を生成し配列を返す
   * ex. 鶏舎タンク容量：2000kgの場合： [{ton: 0, kg: 0}, {ton: 1, kg: 1000}, {ton: 2, kg: 2000}]
   * @param keisha
   */
  genFeedTankObjList(keisha: Keisha) {
    return this.genSequentialNumberObj(keisha.feedTankCapacity ? (keisha.feedTankCapacity / 1000) + 1 : keisha.feedTankCapacity_t + 1, 0);
  }

  /**
   * 餌タンクのラベル用の文字列を返す。
   * @param feedTankQuantity
   * @param index
   */
  feedTankLabel(feedTankQuantity: number[], index: number): string {
    return '餌タンク' + this.genfeedTankKind(feedTankQuantity, index) + '残量(ｔ)';
  }

  /**
   *
   * @param feedTankQuantity
   * @param index
   */
  genfeedTankKind(feedTankQuantity: number[], index: number) {
    if (feedTankQuantity.length === 1) {
      return '';
    }
    if (feedTankQuantity.length === 2) {
      return index === 1 ? '左' : index === 2 ? '右' : '';
    }
    return index.toString();
  }

  /**
   * ツールチップ表示の Callback
   * @param tooltipItem マウス位置にあるアイテム
   * @param data グラフの全データ
   */
  standardTooltip = (tooltipItem: Chart.ChartTooltipItem, data: Chart.ChartData): string | string[] => {
    let retval = '';
    if (typeof data.datasets !== 'undefined' && typeof tooltipItem.datasetIndex !== 'undefined') {
      const dataset = data.datasets[tooltipItem.datasetIndex];
      // const dataset = ['a','b'];
      if (typeof dataset.data !== 'undefined' && typeof tooltipItem.index !== 'undefined') {
        retval = ' ' + dataset.label + '    ' + dataset.data[tooltipItem.index];
      }
    }

    if (retval === null) {
      retval = tooltipItem.yLabel.toString();
    }

    return retval;
  };

  /**
   *
   * @param year
   * @param month
   */
  gesshoDateString(year:number, month: number) {
    return this.getDateWithString(new Date(year, month - 1, 1));
  }

  /**
   *
   * @param year
   * @param month
   */
  getsumatsuDateString(year:number, month: number) {
    return this.getDateWithString(new Date(year, month, 0));
  }

  /**
   * 2つの日付の差分を取得
   *
   * @param date1 yyyy-MM-dd 形式文字列
   * @param date2 yyyy-MM-dd 形式文字列
   * @returns date2 と date1 の日数差分。date2 が後のときが正。
   */
  getDateDiff = (date1: string, date2: string): number => {
    // let d1 = new Date(date1.replace(/-/g, "/"));
    // let d2 = new Date(date2.replace(/-/g, "/"));
    const d1 = this.convertDateStringToObject(date1);
    const d2 = this.convertDateStringToObject(date2);

    const msDiff = d2.getTime() - d1.getTime();

    return Math.floor(msDiff / (1000 * 60 * 60 * 24));
  };

  convertDateStringToObject = (date: string): Date => {
    const year = date.substring(0, 4);
    const month = date.substring(5, 7);
    const day = date.substring(8, 10);
    if (date.length < 19) { // yyyy-MM-dd 形式
      return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
    }
    const hour = date.substring(11, 13);
    const min = date.substring(14, 16);
    const sec = date.substring(17, 19);
    if (date.length < 23) { // yyyy-MM-dd HH:mm:ss 形式
      return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10),
        parseInt(hour, 10), parseInt(min, 10), parseInt(sec, 10));
    }
    const ms = date.substring(20, 23);
    return new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10),
      parseInt(hour, 10), parseInt(min, 10), parseInt(sec, 10), parseInt(ms, 10));
  };

  /**
   * timestamp型からdate型に変換
   * timestamp型のままだとDatepickerとのバインドに不都合があるため
   * @param model
   */
  changeTimeStampToDate(model: any) {
    const newModel = {...model};
    Object.keys(model).forEach(key => {
      if (this.isContains(key, ['Date'])
        && newModel[key] !== null) {
        newModel[key] = newModel[key].toDate();
      }
    });
    return newModel;
  }

  /**
   * dateRangepickerのValidating
   * @param fg fg(formGroup)のpropertyは fcStart, fcEndであること
   */
  fgValidating(fg: dateRangeFormGroup) {
    // from/to両方の日付が揃っているか
    if (!fg.value || !fg.value.fcStart || !fg.value.fcEnd) {
      return false;
    }
    return this.fromToValidating(fg.value.fcStart, fg.value.fcEnd);
  }

  /**
   * 日付期間指定の値が両方揃っているか、
   * 日付の前後関係が正しいかチェック
   * @param fromDate
   * @param toDate
   */
  fromToValidating(fromDate: string | null | undefined, toDate: string | null | undefined) {
    // from/to両方の日付が揃っているか
    if (!fromDate || !toDate) {
      return false;
    }
    // fromとtoの関係が逆転していないか
    if (fromDate > toDate) {
      return false;
    }
    return true;
  }

  /**
   * dateRangePickerにバインドされている値は
   * yyyy/MM/dd形式なのでyyyy-MM-dd形式に置換
   *
   * '/'が含まれていない場合はそのまま返す
   * @param date
   */
  formatDateRangePickerDate(date: string): string {
    if (date.includes('/')) {
      return date.replace(/\//g, '-');
    }
    return date;
  }

  /**
   * str に checkStrList 内の値が含まれているかチェック
   * 含まれている場合、true
   * @param str
   * @param checkStrList
   */
  isContains(str: string, checkStrList: string[]): boolean {
    if (checkStrList.length > 0) {
      for (const checkStr of checkStrList) {
        if (str.indexOf(checkStr) !== -1) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * object空判定メソッド 空ならtrue
   * https://www.deep-rain.com/programming/javascript/910
   * @param obj
   */
  objectIsEmpty<T extends object>(obj: T) {
    return !Object.keys(obj).length;
  }

  /**
   * objectのarrayを指定されたkeyでソートする
   * デフォルトでは昇順
   * keyの値がundefinedだった明細はundefinedでは無い明細の後ろにソートされる
   * @param array 並び替える対象
   * @param key 指定されたkey名のプロパティ値でソート
   * @param asc 昇順/降順切り替え デフォルトでは昇順、falseをセットした場合、降順
   */
  sortObjectArray<T>(array: T[], key: string, asc = true): T[] {
    array.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      if (a[key] !== 0 && !a[key]) {
        return 1;
      }
      if (b[key] !== 0 && !b[key]) {
        return -1;
      }
      if (a[key] < b[key]) {
        return asc ? -1 : 1;
      }
      if (a[key] > b[key]) {
        return asc ? 1 : -1;
      }
      return 0;
    });
    return array;
  }

  /**
   * Objectの配列をソート
   * https://qiita.com/nkk777dev/items/40b39cd80df55ed4ac2b
   * @param a
   * @param b
   * @param key ソートを行うプロパティ名
   * @param direction 1なら昇順、-1なら降順
   * @param nullsFirst 1ならnullまたはundefinedを先、-1ならnullまたはundefinedを後にソート
   */
  defaultSortFunc<T>(a: T, b: T, key: keyof T, direction: 1 | -1 = 1, nullsFirst: 1 | -1 = 1) {
    const aIsFalsy = this.isNullOrUndefined(a[key]);
    const bIsFalsy = this.isNullOrUndefined(b[key]);
    if (aIsFalsy && bIsFalsy) {return 0;}
    if (aIsFalsy) {return nullsFirst * 1;}
    if (bIsFalsy) {return nullsFirst * -1;}
    if (a[key] > b[key]) {return direction * 1;}
    if (a[key] < b[key]) {return direction * -1;}
    return 0;
  }

  /**
   * Objectの配列を複数のKeyでソート
   * https://qiita.com/nkk777dev/items/40b39cd80df55ed4ac2b
   * @param data
   * @param keys {key: sortしたいプロパティ名, direction: 1なら昇順、-1なら降順}
   */
  sortMultiKeys<T>(data: T[], keys: {key: keyof T, direction: 1 | -1}[]) {
    if (!data.length) {
      return data;
    }
    const tempData = data.slice();
    tempData.sort((a, b) => {
      let order = 0;
      keys.some(key => {
        order = this.defaultSortFunc(a, b, key.key, key.direction);
        return !!order;
      });
      return order;
    });
    return tempData;
  }

  /**
   *
   * @param master
   * @param id
   * @param keyPropertyName
   */
  getName(master: any[], id: string | null = null, keyPropertyName = 'name') {
    if (!id) { return ''; }
    const meisai = master.find(row => {
      return row.id === id;
    });
    if (typeof meisai !== 'undefined' && meisai[keyPropertyName]) {
      return meisai[keyPropertyName];
    }
    return '';
  }

  /**
   * objectの配列から指定したプロパティに一致するobjectを検索し、
   * そのobjectが持つ指定したプロパティを返す
   * @param master 検索対象
   * @param searchPropertyName 検索対象のプロパティ名
   * @param searchValue 検索値
   * @param returnPropertyName リターンしてほしいプロパティ名
   */
  getValue<T, U>(master: T[], searchPropertyName: keyof T, searchValue: any, returnPropertyName: keyof T): U | string {
    const meisai = master.find(row => {
      return row[searchPropertyName] === searchValue;
    });
    if (typeof meisai !== 'undefined' && meisai[returnPropertyName]) {
      return meisai[returnPropertyName] as unknown as U;
    }
    return '';
  }

  /**
   * objectの配列から特定のPropertyを取り出して配列を生成する
   * @param array
   * @param propertyName
   */
  getSpecifiedProperties(array: any[], propertyName: string) {
    const values: any[] = [];
    array.forEach((row: any) => {
      if (typeof row !== 'undefined' && typeof row[propertyName] !== 'undefined') {
        values.push(this.numToNumber(row[propertyName]));
      }
    });
    return values;
  }

  /**
   * objectの配列から特定のPropertyを取り出して配列を生成する
   * 未定義の場合はnullで埋める
   * TODO: getSpecifiedPropertiesからこちらの関数に切り替えた方がいい箇所があるかも
   * @param array
   * @param propertyName
   */
  getSpecifiedPropertiesWithFill(array: any[], propertyName: string) {
    const values: any[] = [];
    array.forEach((row: any) => {
      // undefinedとnullの両方をnullとして扱い、Chart.jsでプロットしないようにする
      if (typeof row !== 'undefined' && row[propertyName] != null) {
        values.push(this.numToNumber(row[propertyName]));
      } else {
        values.push(null);
      }
    });
    return values;
  }

  // https://yucatio.hatenablog.com/entry/2019/12/10/222311
  /**
   *
   * @param array
   * @param number
   */
  sliceByNumber(array: any[], number: number) {
    const length = Math.ceil(array.length / number);
    // @ts-ignore
    return new Array(length).fill().map((_, i) =>
      array.slice(i * number, (i + 1) * number)
    );
  }

  /**
   * ngForのpipe、「keyvalue」使用時に列挙される順番を元データ通りに並び替え
   * https://stackoverflow.com/questions/52793944/angular-keyvalue-pipe-sort-properties-iterate-in-order
   * @param a
   * @param b
   */
  // Preserve original property order
  originalOrder = (a: KeyValue<number, string>, b: KeyValue<number, string>): number => {
    return 0;
  };
  // Order by property key
  keyOrder = <T, V>(a: KeyValue<T, V>, b: KeyValue<T, V>): number => {
    return a.key < b.key ? -1 : b.key < a.key ? 1 : 0;
  };
  originalStrOrder = (a: KeyValue<string, string>, b: KeyValue<string, string>): number => {
    return 0;
  };

  // object内のプロパティをソート
  /**
   *
   * @param unordered
   */
  sortObjectProperties(unordered: any) {
    return Object.keys(unordered).sort().reduce(
      (obj: any, key: string) => {
        obj[key] = unordered[key];
        return obj;
      },
      {}
    );
  }

  // objectの中のobjectを見に行けるように修正する必要あり
  /**
   *
   * @param origin
   * @param object
   * @param property
   */
  checkValueUpdated(origin: any, object: any, property: string): boolean {
    const isEmpty = (op: any) => Boolean(op === null || typeof op === 'undefined' || op === '' || op === [] || op === {});
    // originに指定したkeyが存在しないが、objectには値がある場合true
    if (!origin || !Object.keys(origin).some((key:string) => key === property)) {
      return isEmpty(object[property]) ? false : true;
    }
    if (origin[property] === object[property] || isEmpty(origin[property]) && isEmpty(object[property])) {
      return false;
    }
    return true;
  }

  // objectの中のobjectを見に行けるように修正する必要あり
  /**
   * origin と currentの中のpropertyを比較
   * 一致しなければ true
   * @example
   * checkValueUpdatedV2({a: {b: 11}}, {a: {b: 11}}, 'a', 'b') // -> false
   * checkValueUpdatedV2({a: {b: 11}}, {a: {b: 22}}, 'a', 'b') // -> true
   * @param origin 何らかのObject
   * @param current 何らかのObject
   * @param properties 比較対象のpropertyへのpath、上の階層から一つずつ渡す
   */
  checkValueUpdatedV2(origin: KeyString<any>, current: KeyString<any>, ...properties: (string | number)[]): boolean {
    const isEmpty = (op: any) => Boolean(op === null || typeof op === 'undefined' || op === '');
    const originValue = this.getNestedValue(origin, ...properties);
    const currentValue = this.getNestedValue(current, ...properties);
    // originに指定したkeyが存在しないが、currentには値がある場合true
    if (typeof originValue === 'undefined') {
      return isEmpty(currentValue) ? false : true;
    }
    if (originValue === currentValue || isEmpty(originValue) && isEmpty(currentValue)) {
      return false;
    }
    return true;
  }

  /**
   * properties で指定された object 内の値を返す
   * @example
   * getRootValue({a: {b: 11}}, 'a', 'b') // -> 11
   * @param object 何らかのObject
   * @param properties 取得対象のpropertyへのpath、上の階層から一つずつ渡す
   */
  getNestedValue(object: KeyString<any>, ...properties: (string | number)[]) {
    let val = object;
    for (const i of properties) {
      if (typeof val[i] === 'undefined') {
        return undefined;
      }
      val = val[i];
    }
    return val;
  }

  /**
   * 二つの値の差を計算（小数点第一位で四捨五入）
   * 前者から後者を引く（前者が大きいと正の値が返る）
   * @param minuend
   * @param subtracter
   */
  calcDifference(minuend: number | undefined, subtracter: number | undefined) {
    let num = 0;
    if (minuend && subtracter) {
      num = Math.round((minuend - subtracter)*10) /10;
    }
    return num ? num : '';
  }

  // 餌付け日=1日齢とするため+1
  /**
   *
   * @param edukeDate
   * @param hikakuDate
   */
  calcNichirei(edukeDate: string, hikakuDate: string = this.getDateWithString()) {
    return this.getDateDiff(edukeDate, hikakuDate) +1;
  }

  /**
   * 全数出荷済の場合、出荷日時点の日齢になる。
   * 入荷済みであれば餌付け日から計算した日齢
   * 入荷前であれば「未入荷」を返す
   * @param shiyoulot
   */
  getShiyoulotNichirei(shiyoulot: ShiyoulotV2) {
    const genzaiWasuu = this.calcGenzaiWasuuForShiyoulotFile(shiyoulot);
    if (!shiyoulot.isMiNyuuka) {
      if (genzaiWasuu < 1) {
        return this.calcNichirei(this.getEdukeDate(shiyoulot), shiyoulot.shukkaDate);
      } else {
        return this.calcNichirei(this.getEdukeDate(shiyoulot));
      }
    }
    return '未入荷';
  }

  // 日付とその日付時点の日齢から餌付け日を計算して返す。
  // 当日分をoffsetするために-1
  /**
   *
   * @param date
   * @param nichirei
   */
  calcEdukeDate(date: string, nichirei: number) {
    return this.genOffsetDateWithStandardDateString(date, -(nichirei - 1));
  }

  /**
   * 飼養ロット日別ファイルからその日時点の現在羽数を計算
   * 現在羽数 = 飼養ロット日別ファイル.現在羽数
   *  + 飼養ロット日別ファイル.訂正羽数
   *  - 飼養ロット日別ファイル.斃死羽数
   *  - 飼養ロット日別ファイル.淘汰羽数
   *  + 飼養ロット日別ファイル.入荷羽数
   *  - 飼養ロット日別ファイル.出荷羽数
   * @param shiyoulotHibetsuFile
   * @param returnZeroIfNegative 現在羽数がマイナスの場合、0を返すか
   */
  calcGenzaiWasuuForShiyoulotHibetsuFile(
    shiyoulotHibetsuFile: ShiyoulotHibetsuFile,
    returnZeroIfNegative: boolean = true
  ): number {
    let genzaiWasuu = 0;
    if (!shiyoulotHibetsuFile) {
      return genzaiWasuu;
    }
    genzaiWasuu = shiyoulotHibetsuFile.genzaiWasuu
      ? shiyoulotHibetsuFile.genzaiWasuu : 0;
    genzaiWasuu += shiyoulotHibetsuFile.teiseiWasuu
      ? shiyoulotHibetsuFile.teiseiWasuu : 0;
    genzaiWasuu -= shiyoulotHibetsuFile.heishiWasuu
      ? shiyoulotHibetsuFile.heishiWasuu : 0;
    genzaiWasuu -= this.calcTouta(shiyoulotHibetsuFile);
    genzaiWasuu += shiyoulotHibetsuFile.nyuukaWasuu
      ? shiyoulotHibetsuFile.nyuukaWasuu : 0;
    genzaiWasuu -= shiyoulotHibetsuFile.shukkaWasuu
      ? shiyoulotHibetsuFile.shukkaWasuu : 0;

    if (returnZeroIfNegative) {
      return genzaiWasuu > 0 ? genzaiWasuu : 0;
    } else {
      return genzaiWasuu;
    }
  }

  /**
   * 飼養ロットファイルから当日の現在羽数を計算
   * 現在羽数 = 飼養ロットファイル.現在羽数
   *  + 飼養ロットファイル.訂正羽数
   *  - 飼養ロットファイル.斃死羽数
   *  - 飼養ロットファイル.淘汰羽数
   *  + 飼養ロットファイル.入荷羽数
   *  - 飼養ロットファイル.出荷羽数
   * @param shiyoulotFile
   */
  calcGenzaiWasuuForShiyoulotFile(shiyoulotFile: any): number {
    let genzaiWasuu = 0;
    if (!shiyoulotFile) {
      return genzaiWasuu;
    }
    genzaiWasuu = shiyoulotFile.genzaiWasuu
      ? shiyoulotFile.genzaiWasuu : 0;
    genzaiWasuu += shiyoulotFile.teiseiWasuu
      ? shiyoulotFile.teiseiWasuu : 0;
    genzaiWasuu -= shiyoulotFile.heishiWasuu
      ? shiyoulotFile.heishiWasuu : 0;
    genzaiWasuu -= shiyoulotFile.toutaWasuu
      ? shiyoulotFile.toutaWasuu : 0;
    genzaiWasuu += shiyoulotFile.nyuukaWasuu
      ? shiyoulotFile.nyuukaWasuu : 0;
    genzaiWasuu -= shiyoulotFile.shukkaWasuu
      ? shiyoulotFile.shukkaWasuu : 0;
    return genzaiWasuu > 0 ? genzaiWasuu : 0;
  }

  /**
   * 鶏舎日別ファイルから指定した種別の羽数を取得
   * @param keishaHibetsuFile
   * @param propertyName
   */
  calcWasuuForKeishaHibetsuFile(keishaHibetsuFile: KeishaHibetsuFile, propertyName: keyof HeishiToutaTeiseiWasuu): number {
    let wasuu = 0;
    if (!keishaHibetsuFile) {
      return wasuu;
    }
    wasuu = keishaHibetsuFile[propertyName] ?? 0;

    return wasuu;
  }

  /**
   * 育成率を返す
   * @param shiyoulot
   */
  getIkuseiRitsu(shiyoulot: ShiyoulotV2) {
    if (shiyoulot.allNyuukaWasuu === 0) {
      return 0;
    }
    const genzaiWasuu = this.calcGenzaiWasuuForShiyoulotFile(shiyoulot);
    const ikuseiRitsu = Math.round((genzaiWasuu + shiyoulot.allShukkaWasuu) / shiyoulot.allNyuukaWasuu * 10000) / 100;
    return ikuseiRitsu ? ikuseiRitsu : 0;
  }

  /**
   * 旧フォーマットの鶏舎日別ファイルのobjectの直下に存在する
   * shiyoulotKey 形式のプロパティ名の配列を返す
   * @param keishaHibetsuFileV1 旧フォーマットの鶏舎日別ファイル
   * @private
   */
  private getHeishiToutaObjKeys(keishaHibetsuFileV1: any): ShiyoulotKey[] {
    return Object.keys(keishaHibetsuFileV1).filter(key => {
      return this.isShiyoulotKey(key);
    });
  }

  /**
   * 使用ロットkey型の文字列か判定
   * @param val
   * @private
   */
  isShiyoulotKey(val: string) {
    return REGEX_SHIYOULOT_KEY.test(val);
  }

  /**
   * イベント対象Idsから飼養ロットのIDを取得
   * 見つからなかった場合は空文字を返す
   * @param eventTaishouIds
   */
  getShiyoulotIdFromEventTaishouIds(eventTaishouIds: string[]) {
    const shiyoulotKey = eventTaishouIds
      .find(val => val.endsWith(SHIYOULOT_KEY_SUFFIX));
    return shiyoulotKey ? shiyoulotKey.slice(0, -2) : '';
  }

  /**
   *
   * @param value
   */
  calcTouta(value: any) {
    let num = 0;
    if (value) {
      Object.keys(HEISHI_TOUTA_PROPERTIES).forEach(genin => {
        if (genin != HEISHI_WASUU && value[genin]) {
          num += value[genin];
        }
      });
    }
    return num;
  }

  // 餌付け日があればそちらを返し、なければ予定餌付け日を返す。
  /**
   * TODO: yoteiEdukeDate は ShiyoulotV2 にはないが
   * 第一期開発の場合、edukeDateが空の場合もあるため残しておく。
   * @param shiyoulot
   */
  getEdukeDate(shiyoulot: any): string {
    return shiyoulot.edukeDate ? shiyoulot.edukeDate
      : shiyoulot.yoteiEdukeDate ? shiyoulot.yoteiEdukeDate
        : '';
  }

  // 導入日があれば導入日を返し、なければ入荷日を返す。
  /**
   * TODO: yoteiNyuukaDate は削除予定
   * @param shiyoulot
   */
  getDounyuuDate(shiyoulot: any): string {
    return shiyoulot.dounyuuDate ? shiyoulot.dounyuuDate
      : shiyoulot.yoteiNyuukaDate ? shiyoulot.yoteiNyuukaDate
        : '';
  }

  /**
   * 育雛ロットなら餌付け日、育成ロットなら導入日を返す
   * TODO: 削除予定
   * @param shiyoulot
   * @param keishaMaster
   */
  getEdukeDounyuuDate2(shiyoulot: ShiyoulotV2, keishaMaster: Keisha[]): string {
    const keishaShubetsu = this.getKeishaShubetsu(shiyoulot.keishaId, keishaMaster);
    if (keishaShubetsu === KEISHA_SHUBETSU.IKUSUU) {
      return this.getEdukeDate(shiyoulot);
    } else if (keishaShubetsu === KEISHA_SHUBETSU.IKUSEI) {
      return this.getDounyuuDate(shiyoulot);
    }
    return '';
  }

  // 飼養ロットが出荷された日付を取得
  // 全羽数出荷されていない場合は、実行当日を返す
  /**
   *
   * @param shiyoulot
   */
  getShiyoulotShukkaDateForKyakusakiTeishutsuChouhyou(shiyoulot: ShiyoulotV2): string {
    let shukkaDate = this.getDateWithString();
    const genzaiWasuu = this.calcGenzaiWasuuForShiyoulotFile(shiyoulot);
    if (genzaiWasuu < 1 && shiyoulot.shukkaDate) {
      shukkaDate = shiyoulot.shukkaDate;
    }
    console.log(shukkaDate);
    return shukkaDate;
  }

  /**
   *  飼養ロットの出荷日を取得
   *  出荷されていない鶏がいる状態で出荷日を過ぎていれば当日日付をセット
   * @param shiyoulot
   */
  getShiyoulotShukkaDate(shiyoulot: ShiyoulotV2): string {
    let shukkaDate = shiyoulot.shukkaDate;
    const today = this.getDateWithString();
    const genzaiWasuu = this.calcGenzaiWasuuForShiyoulotFile(shiyoulot);
    if (genzaiWasuu > 0 && shukkaDate < today) {
      shukkaDate = today;
    }
    console.log(shukkaDate);
    return shukkaDate;
  }

  /**
   * 全てのpropertyがObjectの直下にあったV1から
   * ネストされたpropertyを持つV2に変換
   * @param keishaHibetsuFile
   */
  updateKeishaHibetsuFileV1ToV2(keishaHibetsuFile: any): KeishaHibetsuFile {
    /**
     * 指定したobjectNameが未定義であれば、trueを返す
     * また、objectを定義する
     * @param objectName
     */
    const checkObjIsUndefined = (objectName: string) => {
      if (typeof keishaHibetsuFile[objectName] === 'undefined') {
        keishaHibetsuFile[objectName] = {};
        return true;
      }
      return false;
    };

    /**
     * V1で直下に定義されているプロパティを
     * objectの中に書き込む
     */
    const setKeishaHibetsuFileBelowObj = () => {
      // keishaHibetsuFile直下のobjectのプロパティ名
      const objectNames = [KEISHAHIBETSUFILE_PROPERTY.TEMPERATURE, KEISHAHIBETSUFILE_PROPERTY.ESA_ZAN, KEISHAHIBETSUFILE_PROPERTY.SUIDOU_METER] as const;
      for (const objectName of objectNames) {
        if (!checkObjIsUndefined(objectName)) {
          // 定義済みの場合、処理を行わない
          continue;
        }
        for (const propertyName in keishaHibetsuFile) {
          if (objectName !== propertyName && propertyName.toLowerCase().indexOf(objectName.toLowerCase()) > -1) {
            // 未定義ならV1の値をセット
            if (typeof keishaHibetsuFile[objectName][propertyName] === 'undefined') {
              keishaHibetsuFile[objectName][propertyName] = keishaHibetsuFile[propertyName];
            }
          }
        }
      }
    };

    /**
     * V1の直下にある「1-S」形式のプロパティ名の値を
     * TodayShiyoulotHeishiToutaの中に書き込む
     * @param heishiToutaObjKeys
     */
    const setTodayShiyoulotHeishiTouta = (heishiToutaObjKeys: ShiyoulotKey[]) => {
      if (heishiToutaObjKeys && heishiToutaObjKeys.length) {
        heishiToutaObjKeys.forEach((heishiToutaObjKey: string) => {
          keishaHibetsuFile[KEISHAHIBETSUFILE_PROPERTY.TODAY_SHIYOULOT_HEISHI_TOUTA][heishiToutaObjKey]
            = keishaHibetsuFile[heishiToutaObjKey];
        });
      }
    };

    /**
     * 点灯関連のプロパティが未定義であれば、初期値をセット
     */
    const setTentouKanrenProperties = () => {
      const tentouProperties = ['tentouShoutouJikoku', 'warikomiTentouShoutouJikoku'] as const;
      if (this.isKeishaHibetsuFile(keishaHibetsuFile)) {
        tentouProperties.forEach(property => {
          if (!keishaHibetsuFile[property] || !keishaHibetsuFile[property].length) {
            keishaHibetsuFile[property] = genTentouDefaultValue();
          }
        });
      }
    };

    if (!keishaHibetsuFile) {
      return keishaHibetsuFile;
    }

    // // kindが定義済みの場合V2であるとみなし、処理を中断する。
    // if (keishaHibetsuFile.kind === COLLECTION_NAME.KEISHAHIBETSUFILE) {
    //   return keishaHibetsuFile;
    // }
    keishaHibetsuFile.kind = COLLECTION_NAME.KEISHAHIBETSUFILE;
    // 温度など羽数以外をセット
    setKeishaHibetsuFileBelowObj();

    // 羽数関連
    // 定義済みの場合、処理を行わない
    if (checkObjIsUndefined(KEISHAHIBETSUFILE_PROPERTY.TODAY_SHIYOULOT_HEISHI_TOUTA)) {
      const heishiToutaObjKeys = this.getHeishiToutaObjKeys(keishaHibetsuFile);
      setTodayShiyoulotHeishiTouta(heishiToutaObjKeys);
    }

    // 異常関連、未定義であれば初期値をセット
    const propertiesArray = [ABNORMAL_PROPERTIES, TAIOU_PROPERTIES];
    propertiesArray.forEach(properties => {
      const keys = this.keysOf(properties);
      keys.forEach(key => {
        if (typeof keishaHibetsuFile[key] === 'undefined') {
          keishaHibetsuFile[key] = false;
        }
      });
    });

    setTentouKanrenProperties();
    return keishaHibetsuFile;
  }

  /**
   *
   * @param shiyoulotHibetsuFile
   */
  updateShiyoulotHibetsuFileV1ToV2(shiyoulotHibetsuFile: any): ShiyoulotHibetsuFile {
    if (!shiyoulotHibetsuFile) {
      return shiyoulotHibetsuFile;
    }
    shiyoulotHibetsuFile.kind = COLLECTION_NAME.HIBETSUFILE;
    if (shiyoulotHibetsuFile.shiyoulotNumber) {
      shiyoulotHibetsuFile.shiyoulotId = shiyoulotHibetsuFile.shiyoulotNumber.toString();
    }
    return shiyoulotHibetsuFile;
  }

  /**
   *
   * @param shubetsu
   * @param param
   * @param value
   * @param amTemps
   * @param pmTemps
   * @param outsideTemps
   */
  sortTemperatureValueToarray(shubetsu: string, param: string, value: number, amTemps: number[], pmTemps: number[], outsideTemps: number[]) {
    if (param.indexOf(shubetsu) > -1) {
      param.indexOf(AM) > -1 ? amTemps.push(value)
        : param.indexOf(PM) > -1 ? pmTemps.push(value)
          : param.indexOf('OutSide') > -1 ? outsideTemps.push(value)
            : console.log('未分類');
    }
  }

  /**
   *
   * @param matrix
   */
  matAverage(matrix: number[]): number | null {
    if (matrix.length === 0) {
      return null;
    }
    let average = 0;
    for (let i = 0; i < matrix.length; i++) {
      average += matrix[i] / matrix.length;
    }
    return Math.round(average * 10) / 10;
  }

  /**
   *
   * @param obj
   */
  objectKeysLength(obj: any) {
    return Object.keys(obj).length;
  }

  /**
   *
   * @param obj
   */
  log(obj: any) {
    console.log(obj);
  }

  /**
   * meisais(object || object[])
   * meisaisがobjectならその直下の
   * meisaisがarrayなら各要素内の直下の
   * willDeletePropertyNamesを削除する
   * TODO: イベント関連で使用するため残す。
   * AbstractEvent に無いプロパティを削除したい場合もあるため。(例: jisshiNichirei)
   * @param meisais
   * @param willDeletePropertyNames
   */
  deletePropertiesFromObject<T>(meisais:any, willDeletePropertyNames: (keyof T)[]) {
    if (Array.isArray(meisais)) {
      meisais.forEach((meisai: T) => {
        this.deletePropertiesFromObject2(meisai, willDeletePropertyNames);
      });
      return meisais as T[];
    }
    this.deletePropertiesFromObject2(meisais, willDeletePropertyNames);
    return meisais as T;
  }

  /**
   * meisais(object[]) 各要素の直下の willDeletePropertyNames を削除した meisai(object[]) を返す
   * @param meisais
   * @param willDeletePropertyNames
   */
  deletePropertiesFromObjectArray2<T>(meisais: T[], willDeletePropertyNames: (keyof T)[]) {
    meisais.forEach((meisai) => {
      this.deletePropertiesFromObject2(meisai, willDeletePropertyNames);
    });
    return meisais;
  }

  /**
   * meisai(object) の直下の willDeletePropertyNames を削除した meisai(object) を返す
   * @param meisai
   * @param willDeletePropertyNames
   */
  deletePropertiesFromObject2<T>(meisai: T, willDeletePropertyNames: (keyof T)[]) {
    willDeletePropertyNames.forEach(propertyName => {
      if (typeof meisai[propertyName] !== 'undefined') {
        delete meisai[propertyName];
      }
    });
    return meisai;
  }

  /**
   * originObjから取り出したい要素だけを含んだ新しいObjを生成して返す
   * @param originObj コピー元となるObj
   * @param selectedProperties 取り出したい要素
   * @param setNull
   */
  genSelectedPropertiesObj(originObj: any, selectedProperties: string[], setNull = false) {
    const obj: any = {};
    selectedProperties.forEach(gaikionPropertyName => {
      if (originObj[gaikionPropertyName]) {
        obj[gaikionPropertyName] = originObj[gaikionPropertyName];
      } else if (setNull) {
        originObj[gaikionPropertyName] = null;
      }
    });
    return obj;
  }

  /**
   * objectからundefinedのプロパティを削除
   * @param meisai
   */
  deleteUndefinedProperties<T>(meisai: T) {
    this.keysOf(meisai).forEach(key => {
      if (typeof meisai[key] === 'undefined') {
        delete meisai[key];
      }
    });
  }

  /**
   * undefinedを含んだ配列からundefinedを取り除く
   * https://qiita.com/suin/items/cda9af4f4f1c53c05c6f
   * @param array
   */
  deleteUndefinedFromArray<T>(array: (T | undefined)[]): T[] {
    return array.filter((val): val is T => typeof val !== 'undefined');
  }

  /**
   * undefinedやnullを含んだ配列からundefinedやnullを取り除く
   * @param array
   */
  deleteUndefinedOrNullFromArray<T>(array: (T | undefined | null)[]): T[] {
    return array.filter((val): val is T => typeof val !== 'undefined' && val !== null);
  }

  /**
   *
   * @param value
   */
  isUndefined(value: any) {
    return typeof value === 'undefined';
  }

  /**
   *
   * @param keishaId
   * @param keishaMaster
   */
  getKeishaShubetsu(keishaId: string | null = null, keishaMaster: Keisha[]) {
    if (!keishaId) { return ''; }
    return this.getName(keishaMaster, keishaId, 'keishaShubetsu');
  }

  /**
   * uniqueな文字列を生成
   * 各画面要素に一意のnameを付与するため、objectごとにuniqueなIdをセット
   * https://qiita.com/coa00/items/679b0b5c7c468698d53f
   * @param myStrong
   */
  genUniqueStr(myStrong?: number): string {
    let strong = 1000;
    if (myStrong) { strong = myStrong; }
    return (
      new Date().getTime().toString(16)
      + Math.floor(strong * Math.random()).toString(16)
    );
  }

  /**
   * 数字なら数値に変換
   * 数値でなければそのまま返す
   * @param num
   */
  numToNumber(num: any): number | any {
    return ((n: number, val: any) => isNaN(n) ? val : n)(Number(num), num);
  }

  /**
   * numToNumber()だと空文字を渡した時
   * 「0」に変換されてしまうため別処理を追加。
   * 問題なければnumToNumber()を以下のように修正したい。
   * @param num
   */
  numToNumber2(num: any): number | any {
    if (!num) {
      return num;
    }
    return ((n: number, val: any) => isNaN(n) ? val : n)(Number(num), num);
  }

  /**
   * 文字列になっているtrue,falseをboolean型に変換
   * @param bool
   */
  boolToBoolean(bool: any): boolean | any {
    return bool.toLowerCase() === 'true' ? true : bool.toLowerCase() === 'false' ? false : this.numToNumber(bool);
  }

  /**
   *
   * @param year
   * @param month
   */
  getNextMonth(year: any, month: any) {
    if(typeof year == 'string' || typeof month == 'string') {
      year = Number(year);
      month = Number(month);
    }
    if(month === 12) {
      year++;
      month = 1;
    } else {
      month++;
    }
    const result = {year:year, month:month};
    return result;
  }

  /**
   *
   * @param year
   * @param month
   */
  getPrevMonth(year: any, month: any) {
    if(typeof year == 'string' || typeof month == 'string') {
      year = Number(year);
      month = Number(month);
    }
    if(month === 1) {
      year--;
      month = 12;
    } else {
      month--;
    }
    const result = {year:year, month:month};
    return result;
  }

  // https://qiita.com/FumioNonaka/items/fee07b53fd277b218c97
  calcMean(array: number[]) {
    const mean = array.reduce((previous, current) =>
      previous + current  // 要素をすべて足す
    , 0) / array.length;  // 平均を求める
    return Math.round(mean * 10) / 10;  //四捨五入
  }

  /**
   *
   * @param array
   * @param average
   */
  calcStandardDeviation(array: number[], average: number) {
    return Math.sqrt(  // 分散の平方根を求める
      array.map((current) => {  // 各要素について
        const difference = current - average;  // 平均値との差を求める
        return difference ** 2;  // 差を2乘する
      })
        .reduce((previous, current) =>
          previous + current  // 差の2乗をすべて足す
        ) / array.length  // 差の2乗の平均が分散
    );
  }

  /**
   * W01形式の文字列を返す
   * @param week
   */
  genWNN(week: number): string {
    const weekNN = week.toString().padStart(2, '0');
    return 'W' + weekNN;
  }

  /**
   * W01形式の文字列から数値部分を取り出して返す
   * @param wnn
   */
  stripWNN(wnn: string): string {
    return wnn.replace('W0', '').replace('W', '');
  }

  // https://stackoverflow.com/a/45964626
  /**
   *
   * @param val
   */
  asAny(val: any): any {
    return val;
  }

  /**
   * Objectのkey数の2倍を返す
   * keyが0の場合
   * @param obj
   */
  twiceKeysCount(obj: any) {
    return obj && Object.keys(obj)?.length ? Object.keys(obj).length * 2 : 0;
  }

  /**
   * 渡されたファイルがcsvファイルかチェック
   * https://www.10nin.com/crossplatform/windows/csv/2020/10/30/CrossBrowserCSV.html
   * @param file
   */
  isCSV(file: File) {
    if (!file || !file.type) {
      return false;
    }
    return !!(file.type.match(/excel/)
      || file.type.match(/octet-stream/)
      || file.type.match(/csv/));
  }

  /**
   * modalを閉じる際の共通処理
   * @param ref
   * @param res
   */
  onClick<T>(ref: MatDialogRef<T>, res: any = null) {
    // ボタンを押したエフェクトを確認できるようにクローズまでタイムラグを設ける。
    setTimeout(() => {
      this.close(ref, res);
    }, 300);
  }

  /**
   * modalを閉じる際の共通処理
   * @param ref
   * @param res
   */
  close<T>(ref: MatDialogRef<T>, res: any = null) {
    ref.close(res);
  }

  /**
   *
   * @param value
   */
  toNum(value: any) {
    if (typeof value === 'string') {
      return Number(value);
    }
    return value;
  }

  /**
   * arrayに含まれる要素がtoDeleteをkeyに持つとき、toDeleteがtrueの要素を削除します。
   * 'toDelete'プロパティを削除するわけではないことに注意。
   * @param array
   */
  removeElemToDelete<T extends ToDelete>(array: T[]): T[] {
    return array
      .filter(elem => {
        return !Object.keys(elem).some((key: string) => key === 'toDelete') || elem.toDelete === false;
      });
  }

  /**
   * toDelete プロパティを true -> false, false -> true に変更する。
   * @param array
   * @param Index
   */
  switchToDelete<T extends ToDelete>(array: T[], Index: number) {
    array[Index].toDelete = !array[Index].toDelete;
  }

  /**
   *
   * @param startTime
   * @param endTime
   */
  genTimeDiffString(startTime: string, endTime: string): string {
    const exp = /^\d{2}:\d{2}$/g;
    if (Boolean(startTime) && Boolean(endTime) && startTime.match(exp) && endTime.match(exp)) {
      const hourStart = Number(startTime.split(':')[0]);
      const minStart = Number(startTime.split(':')[1]);
      const hourEnd = Number(endTime.split(':')[0]);
      const minEnd = Number(endTime.split(':')[1]);
      let sumInMinutes = hourEnd * 60 + minEnd - (hourStart * 60 + minStart);
      sumInMinutes += 60 * 24;
      sumInMinutes %= 60 * 24;
      // console.log(Math.floor(sumInMinutes / 60))
      // console.log(sumInMinutes % 60)
      return ('0' + Math.floor(sumInMinutes / 60)).slice(-2) + ':' + ('0' + sumInMinutes % 60).slice(-2);
    }
    return '';
  }

  /**
   *
   * @param obj
   * @param index
   */
  getObjKey(obj: any, index: number) {
    return Object.keys(obj)[index];
  }

  /**
   *
   * @param value
   */
  emptyWhenFalse(value: any): any {
    return value ? value : '';
  }

  /**
   *
   * @param value
   */
  zeroWhenFalse(value: any): any {
    return value ? value : 0;
  }

  /**
   *
   * @param arr
   */
  copyArray(arr: any) {
    return JSON.parse(JSON.stringify(arr));
  }

  /**
   * 入力を安全にjsonに変換
   * @param input
   */
  jsonParse<T>(input: string): T | null {
    let json = null;
    try {
      json = JSON.parse(input);
    } catch (error) {
      console.log(error);
    } finally {
      return json;
    }
  }

  /**
   * objの配列を指定されたKey毎にGroup化して
   * { key: values } の形にして返す
   * https://qiita.com/nagtkk/items/e1cc3f929b61b1882bd1
   * @param array
   * @param getKey
   */
  groupByOld<K extends PropertyKey, V>(
    array: readonly V[],
    getKey: (cur: V, idx: number, src: readonly V[]) => K) {
    return array.reduce((obj, cur, idx, src) => {
      const key = getKey(cur, idx, src);
      (obj[key] || (obj[key] = []))!.push(cur);
      return obj;
    }, {} as Partial<Record<K, V[]>>);
  }

  /**
   * objの配列を指定されたKey毎にGroup化して
   * { key: values } の形にして返す
   *
   * @param data
   * @param keyFn
   */
  groupBy = <T>(data: T[], keyFn: { (obj: T): string; }) => data.reduce((agg, item) => {
    const groupKey = keyFn(item);
    agg[groupKey] = [...(agg[groupKey] || []), item];
    return agg;
  }, {} as {[key: string]: T[]});

  /**
   * objの配列を指定されたKey毎にGroup化して
   * [key, values][] の形にして返す
   * https://qiita.com/nagtkk/items/e1cc3f929b61b1882bd1
   * @param array
   * @param getKey
   */
  groupByTuple<K, V>(
    array: readonly V[],
    getKey: (cur: V, idx: number, src: readonly V[]) => K
  ): [K, V[]][] {
    return Array.from(
      array.reduce((map, cur, idx, src) => {
        const key = getKey(cur, idx, src);
        const list = map.get(key);
        if (list) { list.push(cur); } else { map.set(key, [cur]); }
        return map;
      }, new Map<K, V[]>())
    );
  }

  /**
   * esc,tabキー以外のキー入力をキャンセルします。
   * @param keyCode
   */
  cancelKeyDown(keyCode: number) {
    // 9：[Tab]
    // 27：[esc]
    return keyCode === 9 || keyCode === 27;
  }

  /**
   *
   * @param a
   * @param b
   */
  XOR(a: boolean, b: boolean) {
    return (a || b) && !(a && b);
  }

  /**
   *
   * @param stringDate
   * @param diff
   */
  getDayFromStringDate(stringDate: string, diff = 0) {
    if (!stringDate) { return; }
    const date = new Date(stringDate);
    const day = (date.getDay() + diff) % 7 < 0 ? 7 + (date.getDay() + diff) % 7 : (date.getDay() + diff) % 7;
    return WEEK[day].name.slice(-3, -1);
  }

  /**
   *
   * @param {...any} arr
   */
  theLargest(...arr: any[]): any {
    return arr.reduce((prev: any, current: any) => {
      if (!current) {
        return prev;
      }
      return prev > current ? prev : current;
    });
  }

  /**
   *
   * @param {...any} arr
   */
  theSmallest(...arr: any[]): any {
    return arr.reduce((prev: any, current: any) => {
      if (!current) {
        return prev;
      }
      return prev < current ? prev : current;
    });
  }

  /**
   *
   * @param subscription
   */
  subScriptionInit(subscription: Subscription) {
    subscription.unsubscribe();
    return new Subscription();
  }

  /**
   *
   * @param term
   * @param item
   */
  vaccineSearchFn(term: string, item: Vaccine) {
    const toHankaku = (str: string) => {
      return str.replace(
        /[Ａ-Ｚａ-ｚ０-９]/g,
        (s: string) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
      );
    };
    term = toHankaku(term).toLowerCase();
    const vaccineName = toHankaku(item.vaccineName).toLowerCase();
    const vaccineKabu = toHankaku(item.vaccineKabu).toLowerCase();
    const maker = toHankaku(item.maker).toLowerCase();
    const touyoHouhou = toHankaku(item.touyoHouhou ? item.touyoHouhou : '').toLowerCase();

    return vaccineName.indexOf(term) > -1
      || vaccineKabu.indexOf(term) > -1
      || maker.indexOf(term) > -1
      || touyoHouhou.indexOf(term) > -1;
  }

  /**
   *
   * @param vaccine
   */
  vaccineDetailText(vaccine: Vaccine): string {
    const properties = ['vaccineKabu', 'maker', 'touyoHouhou'] as const;
    const propertiesToShow = properties.filter(property => vaccine[property]);
    const detailsToShow = this.deleteUndefinedFromArray(propertiesToShow.map(property => vaccine[property]));
    return detailsToShow.reduce((prev: string, current: string) => prev + ' | ' + current);
  }

  /**
   *
   * @param amPm
   * @param selectedKeishaHibetsuFile
   * @param floor
   */
  diffSuidouMeter_m3(amPm: typeof AM | typeof PM,
    selectedKeishaHibetsuFile: WithNullable<KeishaHibetsuFile, 'feed'> | KeishaHibetsuFile,
    floor: number): number | string {
    const prop = {latest: METER_SHUBETSU.latest + floor, am: METER_SHUBETSU.am + floor, pm: METER_SHUBETSU.pm + floor};
    const suidouMeterKeys = Object.keys(selectedKeishaHibetsuFile.suidouMeter);
    const latestMeter = suidouMeterKeys.includes(prop.latest) ? selectedKeishaHibetsuFile.suidouMeter[prop.latest] : undefined;
    const amMeter = suidouMeterKeys.includes(prop.am) ? selectedKeishaHibetsuFile.suidouMeter[prop.am] : undefined;
    const pmMeter = suidouMeterKeys.includes(prop.pm) ? selectedKeishaHibetsuFile.suidouMeter[prop.pm] : undefined;
    const meterDiff = (a: number, b: number) => Math.round((a - b) * 10) / 10;
    if (amPm === AM) {
      return this.isNumber(amMeter) && this.isNumber(latestMeter)
        ? meterDiff(amMeter, latestMeter)
        : '';
    }
    return this.isNumber(pmMeter) && this.isNumber(amMeter)
      ? meterDiff(pmMeter, amMeter)
      : this.isNumber(pmMeter) && this.isNumber(latestMeter)
        ? meterDiff(pmMeter, latestMeter)
        : '';
  }

  /**
   * m3単位の水道消費量をml/羽に変換。
   * (1000 * 1000)の一つ目の1000は m3 → l への変換、二つ目の1000は l → ml への変換
   * @param meterDiffM3
   * @param wasuu
   */
  convertM3ToMl(meterDiffM3: number, wasuu: number) {
    return meterDiffM3 && wasuu !== 0 ? Math.round(meterDiffM3 * (1000 * 1000) / wasuu) : null;
  }

  /**
   * 引数がnumber型か判定する type guard
   * @param val
   */
  isNumber(val: any): val is number {
    return typeof val === 'number';
  }

  /**
   * 引数がstring型か判定する type guard
   * @param val
   */
  isString(val: any): val is string {
    return typeof val === 'string';
  }

  /**
   * 引数がKeishaHibetsuFileか判定する type guard
   * @param val
   */
  isShiyoulotHibetsuFile(val: any): val is ShiyoulotHibetsuFile {
    return val && val.kind && val.kind === COLLECTION_NAME.HIBETSUFILE;
  }

  /**
   * 引数がKeishaHibetsuFileか判定する type guard
   * @param val
   */
  isKeishaHibetsuFile(val: any): val is KeishaHibetsuFile {
    return val && val.kind && val.kind === COLLECTION_NAME.KEISHAHIBETSUFILE;
  }

  /**
   * 渡されたイベントが体測イベントか判定する type guard
   * @param event
   */
  isTaisokuEvent(event: AbstractEvent): event is TaisokuEvent {
    return event.eventShubetsu === TAISOKU;
  }

  /**
   * 渡されたイベントが体測イベントか判定する type guard
   * @param event
   */
  isVaccineEvent(event: AbstractEvent): event is VaccineEvent {
    return event.eventShubetsu === VACCINE;
  }

  /**
   * 配列内に同じ値があるかチェック
   * 同一の値がある場合、trueを返す
   * @param arr
   */
  isDuplicated<T>(arr: T[]) {
    return !!arr.filter((val, index, self) => {
      return self.indexOf(val) !== self.lastIndexOf(val);
    }).length;
  }

  /**
   *
   * @param meisai
   * @param tentouJikan
   */
  refTentouJikanInShoutouJikoku(meisai: any, tentouJikan: string) {
    const exp = /^\d{2}:\d{2}$/g;
    if (tentouJikan.match(exp)) {
      const hourTentouJikoku = Number(meisai.tentouShoutouJikoku[0].start.split(':')[0]);
      const minTentouJikoku = Number(meisai.tentouShoutouJikoku[0].start.split(':')[1]);
      const hourTentouJikan = Number(tentouJikan.split(':')[0]);
      const minTentouJikan = Number(tentouJikan.split(':')[1]);
      let shoutouJikokuInMinutes = hourTentouJikoku * 60 + minTentouJikoku + (hourTentouJikan * 60 + minTentouJikan);
      shoutouJikokuInMinutes += 60 * 24;
      shoutouJikokuInMinutes %= 60 * 24;
      meisai.tentouShoutouJikoku[0].end = ('0' + Math.floor(shoutouJikokuInMinutes / 60)).slice(-2) + ':' + ('0' + shoutouJikokuInMinutes % 60).slice(-2);
    }
  }

  /**
   *
   * @param form
   */
  getAlertTooltipMessage(form: NgForm) {
    let message = '';
    if (form.invalid) {
      message = '＊のついている項目を入力してください。';
    }
    return message;
  }

  /**
   * オブジェクトから特定のプロパティを削除した新しいオブジェクトを返す
   * 引数のオブジェクトは変更しない
   * @param obj オブジェクト
   * @param willDeleteProperties
   */
  omitPropertiesFromObject<T, K extends keyof T>(obj: T, willDeleteProperties: K[]): Omit<T, K> {
    const cloneObj: T = cloneDeep(obj);
    willDeleteProperties.forEach(property => {
      if (typeof cloneObj[property] !== 'undefined') {
        delete cloneObj[property];
      }
    });
    return cloneObj;
  }

  //#region 型関連Util
  /**
   * ObjectのKeyを型安全に取り出す
   * https://stackoverflow.com/a/68446817
   * @param obj
   */
  keysOf<T extends Record<string, any>>(obj: T): Array<keyof T> {
    return Array.from(Object.keys(obj)) as any;
  }

  /**
   * val が obj の keyであるかを判定するtype guard
   * htmlの型コンパイラを黙らせるために必要。
   * @param obj
   * @param val
   * https://github.com/microsoft/TypeScript/issues/23724#issuecomment-384807714
   */
  checkIsObjectKey<T extends Record<string, any>>(obj: T, val: string): val is Extract<keyof T, string> {
    const objectKeys = this.keysOf(obj);
    for (const key of objectKeys) {
      if (key === val) { return true; }
    }
    return false;
  }

  /**
   * Map型から型安全にgetするための処理
   * @param map type Map
   * @param id 取り出す対象のId
   * @param defaultValue 取り出せなかったときのデフォルト値
   * https://typescriptbook.jp/reference/builtin-api/map#%E3%82%AD%E3%83%BC%E3%81%AE%E6%9C%89%E7%84%A1%E3%82%92%E7%A2%BA%E8%AA%8D%E3%81%99%E3%82%8B---has
   */
  getMapValue<T>(map: Map<string, T>, id: string, defaultValue: T) {
    const val = map.get(id);
    if (typeof val !== 'undefined') {
      return val;
    }
    return defaultValue;
  }

  /**
   * 値がnullまたはundefinedであればtrue
   * https://qiita.com/nkk777dev/items/40b39cd80df55ed4ac2b
   * @param val
   */
  isNullOrUndefined(val: unknown) {
    return val === null || typeof val === 'undefined';
  }

  //#endregion

  /**
   * 指定された id を持つhtml要素に適用されているstyleの内、
   * styleNamesで指定されたstyleの値を取り出して返す
   * @param id html要素のId
   * @param styleNames 取得したいstyleの名前
   */
  getStyle(id: string, styleNames = NO_DATA_CLASS_PROPATIES) {
    const styleObj: KeyString<any> = {};
    const elem = document.getElementById(id);
    if (!elem) {
      console.error(`id: ${id} doesn't exist.`);
      return {};
    }
    const style = getComputedStyle(elem);
    styleNames.forEach(styleName => {
      styleObj[styleName] = style[styleName as keyof typeof style];
    });
    return styleObj;
  }

  /**
   * 文字列にある最初の数字を取得
   * @param str
   */
  getNumberFromString(str: string) {
    const numberArray = str.match(/^[0-9]+/);
    return Array.isArray(numberArray) ? numberArray[0] : null;
  }

  /**
   * 特定プロパティの value が同じかチェック：NG->false OK:true を返す
   * 例：checkProp: startNichirei, removeProp: toDelete
   * objArray の各 obj で以下をチェック
   * checkProp (startNichirei) が同じものがあるかチェック
   * removeProp (toDelete) が true の行はチェックしない
   * @param objArray
   * @param checkProp
   * @param removeProp
   */
  hasSamePropValueFromObjArray<T extends keyof U, U>(objArray: Array<U>, checkProp: T, removeProp?: T) {
    const filteredArray = removeProp
      ? objArray.filter(obj => !obj[removeProp]) : objArray;
    const checkPropArray = filteredArray.map(obj => obj[checkProp]);
    return !(new Set(checkPropArray).size !== checkPropArray.length);
  }

  /**
   * 種別 ikusuu, ikusei ->「育雛」「育成」に変換
   * @param item
   */
  changeShubetsuKana(item: string) {
    const itemKana = SHUBETSU_LIST.find(shubetsu => {
      return shubetsu.name === item;
    });
    return itemKana?.nameKana;
  }
  /**
   * 安全に数値を取り出す
   * 数値以外なら0を返す
   * @param value
   */
  getNumberOrZero(value: unknown): number {
    return typeof value === 'number' ? value : 0;
  }

  /**
   * オブジェクトから指定されたプロパティを取り出す
   * 抽出したプロパティを持つ新しいオブジェクトを返す
   * @param meisai
   * @param propetyNames
   */
  extractProps = <T, U extends keyof T>(meisai: T, propetyNames: U[]) => {
    return propetyNames.reduce((acc, propName) => {
      acc[propName] = meisai[propName];
      return acc;
    }, {} as Pick<T, U>);
  }

  /**
   * 数値かどうかを判定
   * @param value
   */
  isNumeric(value: any): boolean {
    return !isNaN(Number(value));
  }
}
